/* img.js
   ----------------------------------------------------------------------
   Responsive photo helpers. scripts/image-variants.mjs writes three
   WebP sizes next to every photo in public/images (name-480.webp,
   name-960.webp, name-1600.webp), and the components build a srcset
   from them so a phone downloads a 480px file for a 250px card instead
   of the 1600px master. `base` is the photo path without extension
   ("/images/session-9"). */

export const WIDTHS = [480, 960, 1600];

export function srcSetFor(base) {
  return WIDTHS.map((w) => `${base}-${w}.webp ${w}w`).join(", ");
}

/* Strips ".jpg" / ".webp" so callers that hold a full file name can
   still build a srcset. */
export function baseOf(src) {
  return String(src).replace(/\.(jpe?g|webp|png)$/i, "");
}

/* How wide the photo is drawn, per layout, so the browser picks the
   right file. Keep these honest: too large wastes bytes, too small
   blurs. */
export const SIZES = {
  /* a card in a 3 (or 4) column grid: full width on phones, half on tablets */
  card: "(max-width: 640px) calc(100vw - 32px), (max-width: 1080px) 50vw, 33vw",
  /* four small photos in a row under a page title */
  strip: "(max-width: 640px) 50vw, (max-width: 1080px) 33vw, 25vw",
  /* the photo half of a split hero */
  half: "(max-width: 920px) 100vw, 50vw",
  /* a background that fills the viewport width */
  full: "100vw",
  /* a thumbnail grid (gallery tiles) */
  tile: "(max-width: 640px) 50vw, (max-width: 1080px) 33vw, 25vw",
  /* a small round portrait */
  avatar: "120px",
};
